import './lancamentos.css';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import TopoIcone from "./TopoIcone";
import { ArrowBigDown } from "lucide-react";
import { Save, X as IconX, ChevronLeft } from "lucide-react";
import { useLocation } from "react-router-dom";





function Entradas() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mensagemSucesso, setMensagemSucesso] = useState(false);
  const usuarioLogado = location.state?.usuario || "USUÁRIO DESCONHECIDO";
  const hoje = new Date();
  const localDate = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
    .toISOString()
    .slice(0, 10);
  const [data, setData] = useState(localDate);

  const [carrinhoCodigo, setCarrinhoCodigo] = useState("");
  const [carrinhos, setCarrinhos] = useState([]);
  const [alertaSaida, setAlertaSaida] = useState(false);
  const [rotaDestino, setRotaDestino] = useState("");
  const [qtdeEsperada, setQtdeEsperada] = useState("");
  const [esperadoDesativado, setEsperadoDesativado] = useState(false);
  const formatarData = (valor) => {
    if (!valor) return '';
    const [ano, mes, dia] = valor.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  const [importando, setImportando] = useState(false);

 






  const limparFormulario = () => {
    const hoje = new Date();
    const dataLocal = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
      .toISOString()
      .slice(0, 10);
    setData(dataLocal);
    setCarrinhoCodigo("");
    setCarrinhos([]);
    setEsperadoDesativado(false);
    setQtdeEsperada("");
  };



  const salvarCarrinhos = async () => {
  try {
    const token = sessionStorage.getItem("token");

    const response = await fetch(`${process.env.REACT_APP_API}/entradas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        carrinhos,
        dataImportacao: data,
        user: usuarioLogado
      }),
    });

    console.log("📬 Resposta recebida:", response); // 👈 ADICIONE ESTA LINHA

    if (!response.ok) {
      throw new Error("Erro na resposta do servidor");
    }

    setMensagemSucesso(true);
    setTimeout(() => {
      setMensagemSucesso(false);
      limparFormulario();
    }, 2500);

    limparFormulario();
  } catch (error) {
    console.error("❌ Erro ao salvar:", error); // 👈 Já ajuda também
    alert("Erro ao salvar carrinhos.");
  }
};


  const confirmarTrocaDeTela = (rota) => {
    if (carrinhos.length > 0) {
      setRotaDestino(rota);
      setAlertaSaida(true);
    } else {
      navigate(rota);
    }
  };

const handleFileUpload = (e) => {
  const file = e.target.files[0];

  if (!file) {

    return;
  }

  setCarrinhoCodigo(file.name);
  setImportando(true);           // 👈 mostra o loading se quiser

  const reader = new FileReader();
  reader.onload = (event) => {


    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];

    const jsonData = XLSX.utils.sheet_to_json(sheet, {
      range: 1,
      header: "A",
      defval: ""
    });
    
const colA = jsonData.map(row => parseInt(row.A)).filter(n => !isNaN(n));
const ultimoValor = colA.length > 0 ? colA[colA.length - 1] : "";


      const colB = jsonData.map(row => row.B);
      const colC = jsonData.map(row => {
        const excelDate = row.C;
        const jsDate = XLSX.SSF.parse_date_code(excelDate);
        return jsDate ? `${String(jsDate.d).padStart(2, '0')}/${String(jsDate.m).padStart(2, '0')}/${jsDate.y}` : "";
      });

const combinados = colB
  .map((item, i) => {
    let codigoOriginal = String(item).toUpperCase().trim();

    // 🔧 Remove zeros à esquerda do código após o prefixo
    const codigoPadronizado = codigoOriginal
      .replace(/^CAR0+(\d+)$/, "CAR$1")
      .replace(/^BEN0+(\d+)$/, "BEN$1");

    return {
      codigo: codigoPadronizado,
      retirada: colC[i]
    };
  })
  .filter(obj => /^CAR\d+$/i.test(obj.codigo) || /^BEN\d+$/i.test(obj.codigo));
  

      setCarrinhos(combinados);
      setQtdeEsperada(ultimoValor);
      setEsperadoDesativado(true);
      setImportando(false); // 👈 E aqui você desativa o loading no final
    };

    reader.readAsArrayBuffer(file);
  };


  return (
    <div className="lancamento-container">
      {mensagemSucesso && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e6f9ec',
          color: '#10693e',
          padding: '0.75rem 1.25rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 400,
          fontSize: '0.95rem',
          whiteSpace: 'nowrap' // 👈 isso evita a quebra de linha
        }}>
          <span style={{ fontSize: '1.25rem' }}>✅</span>
          Carrinhos importados com sucesso!
        </div>
      )}



      <div className="lancamento-dark-header">
        <TopoIcone icone={<ArrowBigDown size={20} color="#00664F" />} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            gap: '0.5rem',
            padding: '0 1rem',
            height: '40px'
          }}
        >
          <div
            onClick={() => confirmarTrocaDeTela("/menu")}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <ChevronLeft size={24} color="white" strokeWidth={2} />
          </div>
          <span style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>
            Entradas
          </span>
        </div>
      </div>


      <div className="lancamento-content">
        <div className="lancamento-ficha">
          <div className="linha-data-e-qtde" style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
            <div style={{ flex: 1 }}>
              <div style={{ width: "100%", overflow: "hidden", marginBottom: "0.4rem" }}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label className="lancamento-label">Data</label>
                  <input
                    type="text"
                    className="lancamento-input"
                    value={formatarData(data)}
                    readOnly
                    onClick={() => document.getElementById("inputDataReal").showPicker?.()} // dispara o calendário nativo
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      color: "#000",
                      backgroundColor: "#f0faf7",
                      cursor: "pointer"
                    }}
                  />
                  <input
                    id="inputDataReal"
                    type="date"
                    value={data}
                    onChange={(e) => setData(e.target.value)}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer"
                    }}
                  />
                </div>

              </div>

            </div>

            <div style={{ flex: 1, position: "relative" }}>
              <label className="lancamento-label" translate="no">Esperado</label>
              <input
                type="number"
                className="lancamento-input"
                value={qtdeEsperada}
                onChange={(e) => {
                  const valor = e.target.value;
                  if (valor === "") {
                    setQtdeEsperada("");
                  } else {
                    setQtdeEsperada(parseInt(valor));
                  }
                }}
                min="0"
                step="1"
                disabled={true}
                style={{ paddingRight: "30px" }} // espaço pro X
              />

              {qtdeEsperada !== "" && !esperadoDesativado && (
                <span
                  onClick={() => setQtdeEsperada("")}
                  style={{
                    position: "absolute",
                    right: "3px",
                    top: "55%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    transition: "background 0.2s ease-in-out",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#eee")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <IconX size={14} color="#888" />
                </span>
              )}

            </div>
          </div>

          <div className="lancamento-carrinho-wrapper">
            <label className="lancamento-label">Selecione um arquivo:</label>
            <div className="lancamento-add-carrinho" style={{ position: "relative", marginBottom: "0rem" }}>
              <input type="text" readOnly value={carrinhoCodigo} className="lancamento-input" placeholder="Nenhum arquivo selecionado" style={{ flex: 1 }} />
              
              
<input
  type="file"
  accept=".xlsx, .xls"
  id="fileInput"
  style={{ display: "none" }}
  onClick={(e) => {
    // Limpa valor antigo antes de abrir (sempre dispara onChange mesmo se escolher o mesmo)
    e.target.value = "";
  }}
  onChange={(e) => {
    const file = e.target.files[0];

    if (!file) {
      console.log("🛑 Nenhum arquivo selecionado — cancelado");
      return;
    }

    console.log("📄 Arquivo selecionado!");
    setCarrinhoCodigo(file.name);
    setImportando(true);
    handleFileUpload(e);
  }}
/>






<button
  onClick={() => {
    setCarrinhos([]);
    setQtdeEsperada("");
    setCarrinhoCodigo("");

    const input = document.getElementById("fileInput");

  


    // Limpa valor antigo do input
    input.click(); // Abre o seletor
  }}
  className="lancamento-add-button"
  style={{ width: 'auto', padding: '0 1rem' }}
  title="Buscar planilha"
>
  Buscar
</button>

            </div>
          </div>

          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.75rem', marginBottom: '0.5rem' }}>
              <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
              <span style={{ padding: '0 0.75rem', fontWeight: 'bold', fontSize: '0.95rem', color: '#333' }}>Importados</span>
              <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
            </div>

            <div style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: '#fff',
              boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
              maxHeight: '500px',
              overflowY: 'auto'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                {carrinhos.length > 0 && (
                  <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>Código</th>
                      <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>Retirada</th>
                      <th style={{ padding: '0.5rem', borderBottom: '1px solid #ddd' }}></th>
                    </tr>
                  </thead>
                )}

                <tbody>
                  {carrinhos.length === 0 ? (
                    <tr>
                      <td colSpan={3} style={{ padding: '0.75rem', textAlign: 'center', color: '#777', fontSize: '0.9rem' }}>
                        Nenhum arquivo importado.
                      </td>
                    </tr>
                  ) : (
                    carrinhos.slice().reverse().map((item, i) => {
                      const isLast = i === carrinhos.length - 1;
                      return (
                        <tr key={i}>
                          <td style={{ padding: '0.5rem', borderBottom: isLast ? 'none' : '1px solid #ddd' }}>{item.codigo}</td>
                          <td style={{ padding: '0.5rem', borderBottom: isLast ? 'none' : '1px solid #ddd' }}>{item.retirada}</td>
                          <td style={{ padding: '0.5rem', borderBottom: isLast ? 'none' : '1px solid #ddd' }}></td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div> {/* Fecha ficha */}
      </div> {/* Fecha content */}


      <div className="entradas-btn-group" style={{ flexDirection: "column", alignItems: "center" }}>
        {/* ⚠️ Mensagem acima dos botões */}
        {qtdeEsperada !== "" && Number(qtdeEsperada) !== carrinhos.length && carrinhos.length > 0 && (
          <div style={{
            textAlign: "center",
            marginBottom: "8px"
          }}>
            <div style={{ color: "#b30000", fontSize: "0.9rem", fontWeight: 600 }}>
              ⚠️ Atenção
            </div>
            <div style={{ color: "#b30000", fontSize: "0.85rem", fontWeight: 500 }}>
              A quantidade esperada é diferente da importada!
            </div>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <button
            className="lancamento-btn-cancelar-icon"
            onClick={limparFormulario}
            title="Cancelar"
          >
            <IconX size={24} />
          </button>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <label className="lancamento-label" style={{ textAlign: "center", display: "block" }}>
              Quantidade
            </label>
            <input
              type="text"
              className="lancamento-input"
              value={`${carrinhos.length}`}
              readOnly
              style={{
                textAlign: "center",
                height: "50px",
                fontSize: "2rem",
                width: "250px",
                maxWidth: "100%"
              }}
            />
          </div>

          <button
            className="lancamento-btn-salvar-icon"
            disabled={
              carrinhos.length === 0 || parseInt(qtdeEsperada) !== carrinhos.length
            }
            title={
              carrinhos.length === 0
                ? "Nenhum carrinho adicionado"
                : parseInt(qtdeEsperada) !== carrinhos.length
                  ? "Quantidade diferente do esperado"
                  : "Salvar"
            }
            onClick={salvarCarrinhos}
          >
            <Save size={24} />
          </button>
        </div>
      </div>



      {alertaSaida && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
          <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)', textAlign: 'center', maxWidth: '320px', width: '85%' }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '1.1rem', marginBottom: '0.5rem' }}>
                ATENÇÃO
              </div>
              <div style={{ fontSize: '1rem', color: '#333' }}>
                Você tem um lançamento em andamento. Deseja sair mesmo assim?
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <button onClick={() => navigate(rotaDestino)} style={{ padding: '0.5rem 1rem', backgroundColor: '#ef4444', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                SIM
              </button>
              <button onClick={() => setAlertaSaida(false)} style={{ padding: '0.5rem 1rem', backgroundColor: '#00996D', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                NÃO
              </button>
            </div>
          </div>
        </div>
      )}

      {importando && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '5px solid rgba(255,255,255,0.3)',
            borderTop: '5px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
        </div>
      )}

 
    </div>
  );
}

export default Entradas;
